"use strict";

import Page from "./components/ReservedParkingPage.jsx";

export const auth = true;
export const title = "i18n:reservedParkingPage.pageTitle";
export const Component = Page;
